import React, { useEffect, useState, useRef } from 'react';
import SvgIcon from "./../svg/svg"

const Slider = ({
  imageNumber,
  handleSliderChange,
  onInteraction,
  lastFrameNumber,
  startTotalMinutes,
  timeStep,
  selectedDate,
  selectedView,
  totalMinutes,
  sunrise,
  altitude,
  date,
  sunset,
  hourString,
  previousFirstFrameNumber,
  previousImageNumber,
  selectedImagePath,
}) => {
  const [autoplay, setAutoplay] = useState(false);
  const [autoplayInterval, setAutoplayInterval] = useState(null);
  const autoplayRef = useRef(false); // ref pour suivre l'état dans les callbacks async
  const [currentHour, setCurrentHour] = useState('');
  const wrapperRef = useRef(null);
  const [relativeHour, setRelativeHour] = useState(0);

  // Gestion de la position du slider
  const sliderPosition = lastFrameNumber !== null ? (window.innerWidth > 992 ? ((imageNumber / lastFrameNumber) * 58.75) : ((imageNumber / lastFrameNumber) * 46.5)) : 0;

  // Gestion de l'affichage de l'heure
  useEffect(() => {
    setCurrentHour(hourString);
    // Calcul du numéro d'image à afficher
    const calculatedImage = Math.abs(10 * previousImageNumber + (previousFirstFrameNumber - startTotalMinutes)) / timeStep;
    setRelativeHour(calculatedImage);
  }, [selectedDate, selectedView, imageNumber, lastFrameNumber, startTotalMinutes, timeStep, previousFirstFrameNumber, previousImageNumber, hourString]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!wrapperRef.current.contains(event.target)) {
        // Fermer immédiatement l'autoplay
        setAutoplay(false);
        clearInterval(autoplayInterval);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchmove', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchmove', handleClickOutside);
    };
  }, [autoplayInterval]);
  // Précharge une image et retourne une promesse résolue quand elle est prête (ou après timeout)
  const preloadImage = (frameNum) => {
    return new Promise((resolve) => {
      if (!selectedImagePath || frameNum < 0 || frameNum > lastFrameNumber) {
        resolve();
        return;
      }
      const img = new Image();
      const timeout = setTimeout(resolve, 300); // max 300ms d'attente
      img.onload = () => { clearTimeout(timeout); resolve(); };
      img.onerror = () => { clearTimeout(timeout); resolve(); };
      img.src = selectedImagePath.replace(/\d{4}\./, `${frameNum.toString().padStart(4, '0')}.`);
    });
  };

  // Gestion de l'autoplay
  const readHeliodon = () => {
    onInteraction();
    if (!autoplay) {
      setAutoplay(true);
      autoplayRef.current = true;

      let nextImageNumber = imageNumber + 1;

      const step = async () => {
        if (!autoplayRef.current) return;

        if (nextImageNumber <= lastFrameNumber) {
          // Précharger la frame suivante avant d'afficher
          await preloadImage(nextImageNumber + 1);

          if (!autoplayRef.current) return; // vérifier si stop entre temps

          handleSliderChange({ target: { value: nextImageNumber } });
          nextImageNumber += 1;

          // Planifier la prochaine étape
          const timer = setTimeout(step, 100);
          setAutoplayInterval(timer);
        } else {
          // Fin de l'autoplay
          autoplayRef.current = false;
          setAutoplay(false);
          handleSliderChange({ target: { value: 0 } });
        }
      };

      const firstTimer = setTimeout(step, 100);
      setAutoplayInterval(firstTimer);
    } else {
      // Arrêt de l'autoplay
      autoplayRef.current = false;
      setAutoplay(false);
      clearTimeout(autoplayInterval);
    }
  };


  return (
    <>

      <div className='sliderAutoplay'>
        <div
          className='sliderPlayerButton'
          type='button'
          onClick={readHeliodon}
          ref={wrapperRef}
        >
          {autoplay ? (
            <SvgIcon icon="picto-pause" />
          ) : (
            <SvgIcon icon="picto-play" />
          )}
        </div>
      </div>

      <div className='sliderMainContainer'>

        <div className='sliderContainerTest'>
          <div className='sliderIcons'>
            <div className='horizontalLine'></div>
            <div className='sliderIcon'>
              <SvgIcon icon="picto-moon" />
            </div>
            <div className='sliderIcon'>
              <SvgIcon icon="picto-sun" />
            </div>
            <div className='sliderIcon'>
              <SvgIcon icon="picto-moon" />
            </div>
          </div>
          <div className="sliderContainer">
            <div className='sliderProgress'>
              <input
                type="range"
                min={0}
                max={lastFrameNumber}
                onChange={handleSliderChange}
                onPointerDown={onInteraction}
                step={1}
                value={imageNumber}
              />
              <div className="imageNumber" style={{ left: `${sliderPosition}vw` }}>
                {currentHour}
              </div>
            </div>
          </div>
          <div className='sliderLabels'>
            {window.innerWidth > 992 ? (
              <div className='sliderLabel'> {sunrise &&
                <div>Lever du soleil : {sunrise}</div>
              }
              </div>
            ) : (
              <div className='sliderLabel'>
                <SvgIcon icon="picto-sun" /> {sunrise}
              </div>
            )}
            {window.innerWidth > 992 ? (
              <div className='sliderLabel'> {altitude &&
                <div>Altitude : {altitude}m</div>
              }
              </div>
            ) : (
              <div className='sliderLabel'>
                <SvgIcon icon="picto-altitude" /> {altitude}m
              </div>
            )}
            {window.innerWidth > 992 ? (
              <div className='sliderLabel'> {date &&
                <div>Date : {date}</div>
              }
              </div>
            ) : (
              <div className='sliderLabel'>
                <SvgIcon icon="picto-calendar" /> {date}
              </div>
            )}
            {window.innerWidth > 992 ? (
              <div className='sliderLabel'> {sunset &&
                <div>Coucher du soleil : {sunset}</div>
              }
              </div>
            ) : (
              <div className='sliderLabel'>
                <SvgIcon icon="picto-moon" /> {sunset}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Slider;
